import { Outlet } from 'react-router-dom'
import MobileHeader from './MobileHeader'
import BottomTabBar from './BottomTabBar'
import OfflineBanner from './OfflineBanner'
import PWAInstallBanner from './PWAInstallBanner'
import PWAMetaUpdater from './PWAMetaUpdater'

export default function MobileLayout() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col pt-safe">
      <PWAMetaUpdater />
      <MobileHeader />
      <OfflineBanner />
      <PWAInstallBanner />
      <main className="flex-1 pb-20 overflow-y-auto">
        <Outlet />
      </main>
      <BottomTabBar />
    </div>
  )
}
